<template>
    <div class="o-project-nav" v-if="project">
        <o-project-nav-owner v-if="isOwner" :projectUuid="projectUuid" />
        <o-project-nav-admin v-else-if="isAdmin" :projectUuid="projectUuid" />
        <o-project-nav-translator v-else-if="isTranslator" :projectUuid="projectUuid" />
        <o-project-nav-developer v-else-if="isDeveloper" :projectUuid="projectUuid" />
    </div>
</template>

<script>
import OProjectNavOwner from '@organisms2/o-project-nav-owner'
import OProjectNavAdmin from '@organisms2/o-project-nav-admin'
import OProjectNavTranslator from '@organisms2/o-project-nav-translator'
import OProjectNavDeveloper from '@organisms2/o-project-nav-developer'

import { 
    isOwner,
    isTranslator,
    isDeveloper,
    isAdmin
} from '@utils/helpers'

export default {
    name: 'OProjectNav',
    components: {
        OProjectNavOwner,
        OProjectNavAdmin,
        OProjectNavTranslator,
        OProjectNavDeveloper
    },
    props: {
        projectUuid: {
            type: String,
            required: true
        },
        onGetProjects: {
            type: Function,
            required: true
        }
    },
    computed: {
        isOwner() {
            return isOwner(this.project);
        },
        isTranslator() {
            return isTranslator(this.project);
        },
        isDeveloper() {
            return isDeveloper(this.project);
        },
        isAdmin() {
            return isAdmin(this.project);
        }
    },
    async created() {
        const projects = await this.onGetProjects({ projectUuid: this.projectUuid });
        this.project = projects[0];
    },
    data() {
        return {
            project: null
        }
    }
 }
</script>

<style lang="scss" scoped>
@import 'theme';
</style>
